import React, {Component} from 'react'
import {connect} from 'react-redux';
import {reduxForm} from 'redux-form';
import {realParaNumber} from '../../util/numberUtil';
import Autorizacao from '../../security/Autorizacao';
import {PERFIL_ADMIN, getAdminEmpresa, getGestorEmpresa, getOperadorEmpresa} from '../../security/securityContext';
import {withRouter} from 'react-router-dom';
import Moment from 'react-moment';
import selecionarEmissaoCteOs from '../../actions/cteos/selecionarEmissaoCteOs';
import { mapSituacaoTransmissaoCteOs, situacaoTransmissaoCteOs } from '../../util/constantsUtil';
import ReactTooltip from 'react-tooltip';

export class EmissaoCteOS extends Component {


    exibeBotaoTransmissaoEdicaoDadosNotaFiscalCteOs() {
        if (this.props.cteOS.ultimoHistoricoEmissaoCteOs == null) {
            return true;
        }
        if (this.props.cteOS.ultimoHistoricoEmissaoCteOs != null
            && this.props.cteOS.ultimoHistoricoEmissaoCteOs.situacaotransmissao.chave == situacaoTransmissaoCteOs.erro) {
            return true;
        }

        return false;
    }

    exibeBotaoCancelarNotaFiscal() {
        if (this.props.cteOS.ultimoHistoricoEmissaoCteOs == null) {
            return false;
        }

        return this.props.cteOS.ultimoHistoricoEmissaoCteOs.situacaotransmissao.chave === situacaoTransmissaoCteOs.sucesso &&
            (this.props.cteOS.ultimoHistoricoEventoCte == null ||
                this.props.cteOS.ultimoHistoricoEventoCte.situacaotransmissao.chave === situacaoTransmissaoCteOs.erro);


    }

    exibeBotaoImprimirNota() {
        if (this.props.cteOS.ultimoHistoricoEmissaoCteOs != null
            && this.props.cteOS.ultimoHistoricoEmissaoCteOs.situacaotransmissao.chave == situacaoTransmissaoCteOs.sucesso) {
            return true;
        }

        return false;
    }

    exibirIconeMotivoErro (historico) {
        if (historico != null
                && historico.situacaotransmissao.chave === situacaoTransmissaoCteOs.erro) {

            const motivo = historico.motivo ? historico.motivo.replace(/Rejeição: /, '') : ''

            return <span className="align-self-center tooltip-info">
                    <a data-tip data-for={`cte-os-${historico.id}-${this.props.cteOS.id}`}>
                        <i className="material-icons ajuda-icon" style={{ color: '#000' }}>&#xe147;</i>
                    </a>
                    <div className="tooltip-ut">
                        <ReactTooltip className="tooltip-ut" id={`cte-os-${historico.id}-${this.props.cteOS.id}`}
                                    type="dark" effect="solid">
                        <div className="row">{motivo}</div>
                        </ReactTooltip>
                    </div>
                    </span>
        }

        return ''
    }

    render() {
        return <div className="geral">
            <div className="resumo">
                <div className="row">
                    <div className="col">{this.props.cteOS.id}</div>
                    <div className="col">{this.props.cteOS.dataEmissao && <Moment format="DD/MM/YYYY">{this.props.cteOS.dataEmissao}</Moment>}</div>
                    <div className="col">{this.props.cteOS.tomador ? <>
                        {this.props.cteOS.tomador.nomePessoa && <span>{this.props.cteOS.tomador.nomePessoa}</span>}
                        {this.props.cteOS.tomador.nomeFantasia && <span>{this.props.cteOS.tomador.nomeFantasia}</span>}
                    </> : ''}</div>
                    <div className="col">{this.props.cteOS.descricaoServico}</div>
                    <div className="col">{this.props.cteOS.serie}</div>

                    <div className="col">{realParaNumber(this.props.cteOS.valorServico).toLocaleString('pt-br', {
                        style: 'currency',
                        currency: 'BRL'
                    })}</div>

                    <div className="col">
                        {this.props.cteOS.ultimoHistoricoEmissaoCteOs == null ? 'Em preenchimento' :
                            <span style={{color: mapSituacaoTransmissaoCteOs.get(this.props.cteOS.ultimoHistoricoEmissaoCteOs.situacaotransmissao.chave).textColor}}>
                            {this.props.cteOS.ultimoHistoricoEmissaoCteOs.situacaotransmissao.valor}
                                {this.exibirIconeMotivoErro(this.props.cteOS.ultimoHistoricoEmissaoCteOs)}
                        </span>}
                    </div>

                    <div className="col">
                        {this.props.cteOS.ultimoHistoricoEventoCte == null ? '-' :
                        <span style={{color: mapSituacaoTransmissaoCteOs.get(this.props.cteOS.ultimoHistoricoEventoCte.situacaotransmissao.chave).textColor}}>
                            {this.props.cteOS.ultimoHistoricoEventoCte.situacaotransmissao.valor}
                            {this.exibirIconeMotivoErro(this.props.cteOS.ultimoHistoricoEventoCte)}
                        </span>}
                    </div>

                    <div id='container-botoes' className="col-sm-2 mr-md-n4">
                        <div className='dropdown'>
                            <span className="titulo-mobile">Ações:</span>
                            <button id='menu3pontos' className="btn btn-link btn-acoes btn-sm dropdown" type="button"
                                data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                <i className="material-icons">
                                    &#xe5d4;
                                </i>
                            </button>
                            <div className="dropdown-menu" aria-labelledby="dropdownMenuButton">
                                <div className="botoes">
                                    {this.exibeBotaoTransmissaoEdicaoDadosNotaFiscalCteOs() &&
                                        <Autorizacao perfisPermitidos={[PERFIL_ADMIN,
                                            getGestorEmpresa(this.props.empresaSelecionada.id),
                                            getAdminEmpresa(this.props.empresaSelecionada.id),
                                            getOperadorEmpresa(this.props.empresaSelecionada.id)]}>
                                            <a className="dropdown-item"
                                               data-toggle="modal"
                                               data-target="#modalConfirmacaoTransmissaoCteOs"
                                               onClick={() => {
                                                   this.props.selecionarEmissaoCteOs(this.props.cteOS)
                                               }}>
                                                Transmitir CT-e OS
                                            </a>
                                        </Autorizacao>}
                                    {this.exibeBotaoCancelarNotaFiscal() &&
                                        <Autorizacao perfisPermitidos={[PERFIL_ADMIN,
                                            getGestorEmpresa(this.props.empresaSelecionada.id),
                                            getAdminEmpresa(this.props.empresaSelecionada.id),
                                            getOperadorEmpresa(this.props.empresaSelecionada.id)]}>
                                            <a className="dropdown-item"
                                               data-toggle="modal"
                                               data-target="#modalCancelamentoCteOs"
                                               onClick={() => {
                                                   this.props.selecionarEmissaoCteOs(this.props.cteOS)
                                               }}>
                                                Cancelar Nota Fiscal
                                            </a>
                                        </Autorizacao>}
                                    {this.exibeBotaoImprimirNota() && <Autorizacao perfisPermitidos={[PERFIL_ADMIN,
                                        getGestorEmpresa(this.props.empresaSelecionada.id),
                                        getAdminEmpresa(this.props.empresaSelecionada.id)]}>
                                        <a className="dropdown-item" onClick={() => {
                                            this.props.history.push(`/nota-fiscal-cte-os?cteos=${this.props.cteOS.id}`)
                                        }}>
                                            Imprimir Nota
                                        </a>
                                    </Autorizacao>}
                                    {this.exibeBotaoTransmissaoEdicaoDadosNotaFiscalCteOs() && <Autorizacao perfisPermitidos={[PERFIL_ADMIN,
                                        getGestorEmpresa(this.props.empresaSelecionada.id),
                                        getAdminEmpresa(this.props.empresaSelecionada.id),
                                        getOperadorEmpresa(this.props.empresaSelecionada.id)]}>
                                        <a className="dropdown-item" onClick={() => {
                                            this.props.selecionarEmissaoCteOs(this.props.cteOS);
                                            this.props.history.push('/painel-cadastro-cte-os')
                                        }}>
                                            Editar Dados da Nota
                                        </a>
                                    </Autorizacao>}
                                    {!this.exibeBotaoTransmissaoEdicaoDadosNotaFiscalCteOs() && <Autorizacao perfisPermitidos={[PERFIL_ADMIN,
                                        getGestorEmpresa(this.props.empresaSelecionada.id),
                                        getAdminEmpresa(this.props.empresaSelecionada.id),
                                        getOperadorEmpresa(this.props.empresaSelecionada.id)]}>
                                        <a className="dropdown-item" onClick={() => {
                                            this.props.selecionarEmissaoCteOs(this.props.cteOS);
                                            this.props.history.push('/painel-cadastro-cte-os')
                                        }}>
                                            Visualizar Dados da Nota
                                        </a>
                                    </Autorizacao>}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    }
}

export const mapStateToProps = state => (
    {
        empresaSelecionada: state.empresaSelecionada
    });

export default withRouter(connect(mapStateToProps,
    {
        selecionarEmissaoCteOs
    })(reduxForm({
        form: 'formularioPainelCteOS'
    })(EmissaoCteOS)))